<div class="market-drill-down-container" *ngIf="markets.length > 0">
  <list-gauge-circle-chart [charts]="markets"
                           [titlePosition]="'bottom'"
                           [hasBorderLeft]="false"
                           [chartHeader]="'measure.market_drill_down' | translate"
                           [titleTooltip]="'info_box.measure.local_report' | translate"
                           [statusTooltip]="'info_box.measure.local_report_status' | translate">
  </list-gauge-circle-chart>
</div>
<div *ngIf="markets.length === 0" class="fallback-view">
  <div class="header">
    <span>{{'measure.market_drill_down' | translate}}</span>
  </div>
  <div class="message">
    <span>{{'measure.noData' | translate}}</span>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/measure/content/market-drill-down/market-drill-down.component.html